import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_INFO_TOPIC,
  GET_INFO_TOPICS,
  GET_INFO_TOPIC_BY_INFO_GROUP_ID,
  ADD_INFO_TOPIC,
  UPDATE_INFO_TOPIC,
  DELETE_INFO_TOPIC
} from '@/queries/modules/university-news/info-topic';

export async function getInfoTopics(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPICS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.infoTopic;
    } else {
      context.commit('setSuccess', null);
      return data.getInfoTopics
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPIC,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.infoTopic;
    } else {
      context.commit('setSuccess', null);
      return data.getInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getInfoTopicByInfoGroupID(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_INFO_TOPIC_BY_INFO_GROUP_ID,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getInfoTopicsByInfoGroup;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function addInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_INFO_TOPIC,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addInfoTopic.nameLocal));

      return data.addInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_INFO_TOPIC,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setSuccess', updateItemSuccess(data.updateInfoTopic.nameLocal));

      return data.updateInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteInfoTopic(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_INFO_TOPIC,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', deleteItemSuccess(data.deleteInfoTopic.nameLocal));

      return data.deleteInfoTopic
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

